import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Flame } from 'lucide-react';
export function TopFlashBar() {
  const [timeLeft, setTimeLeft] = useState(29 * 60 + 47);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => setTimeLeft(t => Math.max(0, t - 1)), 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <AnimatePresence data-id="element-353">
      <motion.div initial={{
      y: -50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-[#5a3e0a] via-[#7a5510] to-[#5a3e0a] text-[#faf7f2] shadow-md border-b border-[var(--accent)]/30" data-id="element-354">
        <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent pointer-events-none" animate={{
        x: ['-100%', '200%']
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-355" />
        <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center justify-center gap-2 sm:gap-4 relative z-10 text-[11px] sm:text-xs font-medium flex-wrap" data-id="element-356">
          <div className="flex items-center gap-1.5" data-id="element-357">
            <Flame className="w-3 h-3 text-yellow-300 fill-yellow-300" data-id="element-358" />
            <span className="uppercase tracking-wider font-bold text-yellow-200" data-id="element-359">
              OFERTA DE LANZAMIENTO
            </span>
          </div>
          <span className="hidden sm:inline opacity-40" data-id="element-360">—</span>
          <span className="italic opacity-90" data-id="element-361">Solo $6.39 · Termina en:</span>
          <div className="flex items-center gap-0.5 font-mono font-bold bg-black/30 px-1.5 py-0.5 rounded text-yellow-200" data-id="element-362">
            <span data-id="element-363">{pad(minutes)}</span>
            <span className="animate-pulse" data-id="element-364">:</span>
            <span data-id="element-365">{pad(seconds)}</span>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>;
}